import mYoya from "./yoya.svg";
import mLogo from "./logos/tayari_logo.svg";
import tab from "./tab.svg";
// import logo_horizontal from "./logo_horizontal.svg";

export const YoyaSVG = mYoya;
export const LogoSVG = mLogo;
export const TabSVG = tab;
export const LogoHorizontalSVG = mLogo;
